__turbopack_context__.v({
  "button": "FilterButtonsTemplate-module-sass-module__KTTUpa__button",
  "list": "FilterButtonsTemplate-module-sass-module__KTTUpa__list",
});
